module.exports = {"apiBaseURL":"https://api.staging.rewardsmd.com/v1","apiDateFormat":"YYYY-MM-DD","apiPageSize":30,"appBaseURL":"https://app.staging.rewardsmd.com","fbAppId":"","sentry":{"DSN":"","autoBreadcrumbs":true,"environment":"staging","publicDSN":"","release":"3fbf9f17323385cc22488e93731a7ebf7593c39e"},"website":{"automaticAccountAgreement":true,"socialLogins":true,"title":"RewardsMD"}}


//////////////////
// WEBPACK FOOTER
// ../config/settings.json
// module id = 18
// module chunks = 0